export default "__VITE_ASSET__BnxY_Uyw__"